import React from 'react';
import { HeadingProps } from '@dreamai/types';
import emailIcon from '../../../../icons/headings/email.png';
import standardIcon from '../../../../icons/headings/standard.png';
import websiteIcon from '../../../../icons/headings/website.png';
import notesIcon from '../../../../icons/headings/notes.png';
import { useAgent } from '../../../../contexts/AgentContext';
import { generateColorVariants } from '../../sidebar/threadUtils';
import './heading.scss';

/**
 * Heading component for our DSL
 * Always renders a div containing an icon and h3, regardless of level
 */
const Heading: React.FC<HeadingProps> = ({ level, value, icon, ...props }) => {
  const { selectedAgent } = useAgent();

  // Select icon based on icon prop
  const iconSrc =
    icon === 'email'
      ? emailIcon
      : icon === 'website'
        ? websiteIcon
        : icon === 'notes'
          ? notesIcon
          : standardIcon;

  // Generate color variants from agent's predominant color
  const colorVariants = selectedAgent?.predominantColour
    ? generateColorVariants(selectedAgent.predominantColour)
    : generateColorVariants('#97D5FC'); // fallback to default blue

  // // Create dynamic style for the gradient using the lighter color
  // const dynamicStyle = {
  //   background: `linear-gradient(
  //     180deg,
  //     ${colorVariants.base}33 0%,
  //     ${colorVariants.base}00 50%
  //   ), #fff`,
  // };

  return (
    <div className='heading-component' style={{}}>
      <h3>{value}</h3>
    </div>
  );
};

export default Heading;
